import axiosInstance from "@/utils/AxiosInstance";
import {RequestUserPage} from "@/services/users/entities/RequestUserPage";
import {RequestChangeBalance} from "@/services/users/entities/RequestChangeBalance";
import {RequestSaveUserPermissions} from "@/services/users/entities/RequestSaveUserPermissions";

const BASE_API = '/users';

const getUserPage = async (body: RequestUserPage): Promise<any> => {
    return await axiosInstance.post(`${BASE_API}/page`, body);
}

const getUserByUsername = async (username: string): Promise<any> => {
    return await axiosInstance.post(`${BASE_API}/info`, {username});
}

const changeUserStatus = async (username: string): Promise<any> => {
    return await axiosInstance.put(`${BASE_API}/change-status`, {username});
}

const getBalance = async (username: string): Promise<any> => {
    return await axiosInstance.post(`${BASE_API}/balance`, {username});
}

const addBalance = async (body: RequestChangeBalance): Promise<any> => {
    return await axiosInstance.put(`${BASE_API}/add-balance`, body);
}

const setBalance = async (body: RequestChangeBalance): Promise<any> => {
    return await axiosInstance.put(`${BASE_API}/set-balance`, body);
}

const getUserPermissions = async (username: string): Promise<any> => {
    return await axiosInstance.post(`${BASE_API}/permissions`, {username});
}

const saveUserPermissions = async (body: RequestSaveUserPermissions): Promise<any> => {
    return await axiosInstance.put(`${BASE_API}/change-permissions`, body);
}

const createUser = async (body: any): Promise<any> => {
    return await axiosInstance.post(`${BASE_API}/`, body);
}

const editUser = async (body: any): Promise<any> => {
    return await axiosInstance.put(`${BASE_API}/`, body);
}

const getAvailableDieticians = async (body: any): Promise<any> => {
    return await axiosInstance.post(`${BASE_API}/dieticians/available`, body);
}

const assignDieticianToOffice = async (body: any): Promise<any> => {
    return await axiosInstance.put(`${BASE_API}/dieticians/assign-dietician`, body);
}

const getUserBalance = async (): Promise<any> => {
    return await axiosInstance.get(`${BASE_API}/me/balance`);
}

const getSessionPermissions = async (): Promise<any> => {
    return await axiosInstance.get(`${BASE_API}/me/permissions`);
}

const updateRenovationDate = async (body: any): Promise<any> => {
    return await axiosInstance.patch(`${BASE_API}/dieticians/renovation`, body);
}

const getUserRoyalties = async (): Promise<any> => {
    return await axiosInstance.get(`${BASE_API}/me/royalties`);
}

const updateRoyaltiesStatus = async (body: any): Promise<any> => {
    return await axiosInstance.patch(`${BASE_API}/dieticians/royalties`, body);
}

export default {
    getUserPage,
    getUserByUsername,
    changeUserStatus,
    getBalance,
    addBalance,
    setBalance,
    getUserPermissions,
    saveUserPermissions,
    createUser,
    editUser,
    getAvailableDieticians,
    assignDieticianToOffice,
    getUserBalance,
    getSessionPermissions,
    updateRenovationDate,
    getUserRoyalties,
    updateRoyaltiesStatus
}
